import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Highlight, Icon } from '@node-space/ui-components'
import { useWalletContext } from 'hooks/context'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useAccountPreferencesQuery } from 'hooks/queries/useAccountPreferencesQuery'
import { useIsActiveWallet } from 'hooks/useActiveWallets'
import { formatTotal } from 'pages/Wallets/components/Table/utils'

export const WalletBalance = () => {
  const wallet = useWalletContext()
  const { t } = useTranslation()
  const { profile } = useProfileContext() || {}
  const { currencyCode: baseCurrency } = profile || {}
  const isSelectedWalletActive = useIsActiveWallet(wallet)
  const { data: accountPreferences } = useAccountPreferencesQuery()

  const preferredCurrency = accountPreferences?.currency
  const userCurrency = preferredCurrency || baseCurrency
  const walletCurrency = wallet?.currency?.code
  const walletBalance = wallet?.approxBalance
  const walletConvertedAvailable = wallet?.approxConvertedAvailable

  return (
    <>
      <Box flex align="center" gap={12} className="relative">
        <Avatar name={walletCurrency} />
        <h1 className="text-h1 text-foreground-prominent" data-testid="wallet-balance">
          {!Number(walletBalance)
            ? `${walletBalance} ${walletCurrency}`
            : formatTotal(Number(walletBalance), walletCurrency)}
        </h1>
        {!isSelectedWalletActive && (
          <Highlight
            type="error"
            variant="emphasis"
            iconElement={<Icon name="Lock" size="small" />}
          >
            {t('unavailable').toUpperCase()}
          </Highlight>
        )}
      </Box>
      {walletCurrency !== baseCurrency && Boolean(Number(walletConvertedAvailable)) && (
        <h4 className="text-h4 text-foreground-subdued" data-testid="converted-wallet-balance">
          {`~ ${formatTotal(Number(walletConvertedAvailable), userCurrency)}`}
        </h4>
      )}
    </>
  )
}
